import React from 'react';
import PageTitle from '../components/PageTitle';
import StreamsContainer from '../components/StreamsContainer';
import AdCarousel from '../components/AdCarousel';
import ArchiveContainer from '../components/ArchiveContainer';
import '../styles/common.css';

const SchedulePage = () => {
  return (
    <>
      <PageTitle />
      <StreamsContainer />
      <AdCarousel />
      <ArchiveContainer />
    </>
  );
};

export default SchedulePage;
